import Vue from 'vue'
import Router from 'vue-router'
import auth from '../middleware/auth';

// Layouts
import HorizontalLayout from 'Container/HorizontalLayout'


//routes
import defaultRoutes from './default';

// session components
const LoginOne = () => import('Views/session/LoginOne');
const LockScreen = () => import('Views/session/LockScreen');

Vue.use(Router);

export default new Router({
	mode: 'history',
	routes: [
    defaultRoutes,
		{
			path: '/session/login',
			component: LoginOne,
			meta: {
				title: 'message.login',
				breadcrumb: null
			}
		},
		{
			path: '/session/lock-screen',
			component: LockScreen,
			meta: {
				title: 'Lock Screen',
				breadcrumb: null
			}
		},
	]
})
